/**
 * @generated SignedSource<<fcf8e8a756365986f2fd383cb6476f55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NovaAgentShape = "SINGLE_OUTPUT" | "CONVERSATIONAL" | "%future added value";
export type CreateNovaAgentInput = {
  name: string;
  categoryId: string;
  title: string;
  description: string;
  shape?: NovaAgentShape | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateNovaAgentMutation$variables = {
  input: CreateNovaAgentInput;
};
export type CreateNovaAgentMutation$data = {
  readonly createNovaAgent: {
    readonly agent: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly title: string | null;
        readonly description: string | null;
        readonly categoryId: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateNovaAgentMutation = {
  variables: CreateNovaAgentMutation$variables;
  response: CreateNovaAgentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateNovaAgentPayload",
    "kind": "LinkedField",
    "name": "createNovaAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgentEdge",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateNovaAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateNovaAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d90debb35414ff5894ec6c66851c422",
    "id": null,
    "metadata": {},
    "name": "CreateNovaAgentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateNovaAgentMutation(\n  $input: CreateNovaAgentInput!\n) {\n  createNovaAgent(input: $input) {\n    agent {\n      node {\n        id\n        name\n        title\n        description\n        categoryId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a31e3d1c189ab1c01c7a0ab0556aaab7";

export default node;
